import { Container } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApplicationRoutes } from "../../utils/navigation/applicationRoutes";
import { useAppointmentService } from "../../hooks/api/Appointment";
import { PreVideoCall } from "./preVideoCall";
import { useAuth } from "../../hooks/auth";

export const PreVideoCallContainer = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState<number>(8);
  const [appointment, setAppointment] = useState<{ id: number } | null>();
  const { id } = useParams();
  const { getAppointmentByHash } = useAppointmentService();
  const { isSigned, getToken } = useAuth();
  const getAppointmentByHashRef = useRef(getAppointmentByHash);
  const getTokenRef = useRef(getToken);
  getAppointmentByHashRef.current = getAppointmentByHash;
  getTokenRef.current = getToken;

  const findAppointment = useCallback(async () => {
    if (id) {
      const result = await getAppointmentByHashRef.current(id);
      setAppointment(result);
    }
  }, [id]);

  useEffect(() => {
    const token = getTokenRef.current();
    if (!isSigned || !token || token === "undefined") {
      navigate(ApplicationRoutes.SIGN_IN, { replace: true });
      return;
    }

    void findAppointment();
  }, [findAppointment, isSigned, navigate]);

  const directTo = useCallback(async () => {
    if (appointment) {
      navigate(
        ApplicationRoutes.VIDEO_CALL.replace(":id", String(appointment.id))
      );
    }
  }, [appointment, navigate]);

  const [banner] = useState<
    {
      iconName: "callEnd" | "mic" | "videoCall" | "message" | "file";
      text: string;
    }[]
  >([
    {
      iconName: "videoCall",
      text: "Toque sobre o botão da câmera para habilitar e desabilitar a visualização durante a consulta.",
    },
    {
      iconName: "mic",
      text: "Utilize o botão de microfone para habilitar e desabilitar sua voz.",
    },
    {
      iconName: "callEnd",
      text: "No fim da consulta toque nesse botão para encerrar a ligação.",
    },
    {
      iconName: "message",
      text: "Para digitar algo para o médico utilize o campo de texto.",
    },
    {
      iconName: "file",
      text: "Caso necessite enviar um exame ou receita para o médico, utilize o campo arquivo.",
    },
  ]);
  const [chosenBanner, setChosenBanner] = useState<{
    iconName: "callEnd" | "mic" | "videoCall" | "message" | "file";
    text: string;
  }>(banner[0]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setSeconds((seconds) => seconds - 1);

      // Check if the current time is a multiple of 15 seconds
      if (seconds <= 1) {
        directTo();
      }
    }, 1000);
    return () => clearInterval(timerInterval);
  }, [directTo, seconds]);
  return (
    <Container maxWidth="sm">
      <PreVideoCall
        {...{ seconds, banners: banner, chosenBanner, setChosenBanner }}
      />
    </Container>
  );
};
